import { sharedUS } from "@shared/locales";

// For use on the Remix server only for functions specific to the server like 500 status pages
// If you want to include styles for your application, do so in that applications folder
const US = sharedUS;

export { US };
